export { SupabaseIntegration } from "./v7.js";
export { supabaseIntegration } from "./v8.js";
